export default __webpack_public_path__ + "static/media/logolargesuperfin.a36de4a1.png";